<!-- Accessibility Toolbar -->
<section class="accessibility">
  <div class="accessibility-toolbar d-flex flex-wrap align-items-center justify-content-end px-3 py-1">
    <a class="acc-btn" href="#all" (click)="skipToContent()">
      <i class="acc-icon">⌨</i> Skip to main content
    </a>
    <a class="acc-btn" href="#navbar" (click)="skipToNavigation()">
      <i class="acc-icon">↓</i> Skip to Navigation
    </a>
    <a class="acc-btn" [routerLink]="['/screenreader']">
      <i class="acc-icon">👁</i> Screen Reader
    </a>

    <div class="acc-divider"></div>

    <div class="d-flex align-items-center text-size-group">
      <span class="acc-label">Text:</span>
      <button class="acc-btn text-ctrl" (click)="adjustTextSize('decrease')">A−</button>
      <button class="acc-btn text-ctrl" (click)="adjustTextSize('reset')">A</button>
      <button class="acc-btn text-ctrl" (click)="adjustTextSize('increase')">A+</button>
    </div>

    <div class="acc-divider"></div>

    <a class="acc-btn" (click)="toggleGrayscale()">
      <i class="acc-icon">◑</i> Grayscale
    </a>
    <a class="acc-btn" (click)="toggleHighContrast()">
      <i class="acc-icon">◐</i> High Contrast
    </a>
  </div>
</section>

<!-- Brand Header -->
<header class="brand-header">
  <div class="container">
    <!-- Desktop Layout -->
    <div class="header-inner d-none d-md-flex align-items-center justify-content-between">
      <!-- Left Logos -->
      <div class="logo-group logo-group--left">
        <div class="logo-wrap">
          <img src="assets/images/goseva-logo.png" class="logo logo--rect" alt="पशुसंवर्धन विभाग">
        </div>
        <div class="logo-wrap">
          <img src="assets/images/home/Pashuposhan3.png" class="logo logo--circle" alt="पशुसंवर्धन विभाग">
        </div>
      </div>

      <!-- Center Brand -->
      <div class="brand-center text-center">
        <div class="brand-emblem">
          <div class="brand-title-line"></div>
          <h1 class="brand-title">महाराष्ट्र गोसेवा आयोग</h1>
          <p class="brand-subtitle">महाराष्ट्र शासन</p>
          <div class="brand-title-line"></div>
        </div>
      </div>

      <!-- Right Logos -->
      <div class="logo-group logo-group--right">
        <div class="logo-wrap">
          <img src="assets/images/home/Pashuposhan1.png" class="logo" alt="azadi ka amrit mahotsav">
        </div>
        <div class="logo-wrap">
          <img src="assets/images/home/Pashuposhan2.png" class="logo" alt="YouTube">
        </div>
      </div>
    </div>

    <!-- Mobile Layout -->
    <div class="d-md-none mobile-header">
      <div class="mobile-logos d-flex justify-content-around align-items-center py-2">
        <img src="assets/images/goseva-logo.png" class="logo logo--rect" alt="पशुसंवर्धन विभाग">
        <img src="assets/images/home/Pashuposhan3.png" class="logo logo--circle" alt="पशुसंवर्धन विभाग">
        <img src="assets/images/home/Pashuposhan1.png" class="logo" alt="azadi ka amrit mahotsav">
        <img src="assets/images/home/Pashuposhan2.png" class="logo" alt="YouTube">
      </div>
      <div class="text-center py-2">
        <h1 class="brand-title brand-title--mobile">महाराष्ट्र गोसेवा आयोग</h1>
        <p class="brand-subtitle brand-subtitle--mobile">महाराष्ट्र शासन</p>
      </div>
    </div>
  </div>
</header>

<!-- Navigation Bar -->
<nav id="navbar" class="navbar navbar-expand-lg main-nav" role="navigation" aria-label="Main Navigation">
  <div class="container">
    <!-- Brand/Logo in Navbar -->
    <a routerLink="/webui/home" class="navbar-brand nav-brand">
      <span class="nav-brand-accent">परिपोषण</span>
    </a>

    <!-- Mobile Toggle -->
    <!-- <button
      class="navbar-toggler nav-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="toggler-bar"></span>
      <span class="toggler-bar"></span>
      <span class="toggler-bar"></span>
    </button> -->

    <button class="navbar-toggler nav-toggler d-lg-none" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="toggler-bar"></span>
      <span class="toggler-bar"></span>
      <span class="toggler-bar"></span>
    </button>


    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mx-auto nav-list">

        <li class="nav-item">
          <a class="nav-link nav-link-custom" [ngClass]="{'active-link': isActive('')}" routerLink="/">
            मुख्यपृष्ठ
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link nav-link-custom" [ngClass]="{'active-link': isActive('about-us')}" routerLink="about-us">
            आमच्याबद्दल
          </a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link nav-link-custom dropdown-toggle" id="yojanaDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            योजनांचा तपशील
          </a>
          <ul class="dropdown-menu nav-dropdown" aria-labelledby="yojanaDropdown">
            <li>
              <a class="dropdown-item nav-dropdown-item" [ngClass]="{'active-link': isActive('yojana-tapshil')}"
                routerLink="yojana-tapshil">
                देशी गायींच्या परिपोषणासाठी प्रति दिन अनुदान योजना
              </a>
            </li>
            <!-- <li>
              <a class="dropdown-item nav-dropdown-item"
                [ngClass]="{'active-link': isActive('govarddhan-govansh-yojana')}"
                routerLink="govarddhan-govansh-yojana">
                सुधारित गोवर्धन गोवंश सेवा केंद्र योजना
              </a>
            </li> -->
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link nav-link-custom dropdown-toggle" id="yojanaDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            योजना अर्ज
          </a>
          <ul class="dropdown-menu nav-dropdown" aria-labelledby="yojanaDropdown">
            <li>
              <a class="dropdown-item nav-dropdown-item" [ngClass]="{'active-link': isActive('new-application')}"
                routerLink="new-application">
                देशी गायींच्या परिपोषणासाठी प्रति दिन अनुदान योजना अर्ज करा
              </a>
            </li>
            <li>
              <a class="dropdown-item nav-dropdown-item"
                [ngClass]="{'active-link': isActive('revised/govardhan-govansh-application')}"
                routerLink="revised/govardhan-govansh-application">
                सुधारित गोवर्धन गोवंश सेवा केंद्र योजना अर्ज करा
              </a>
            </li>
          </ul>
        </li>

        <!-- <li class="nav-item">
          <a class="nav-link nav-link-custom" [ngClass]="{'active-link': isActive('new-application')}"
            routerLink="new-application">
            अर्ज करा
          </a>
        </li> -->

        <li class="nav-item">
          <a class="nav-link nav-link-custom" [ngClass]="{'active-link': isActive('timetable')}" routerLink="timetable">
            वेळापत्रक
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="go-ten" [ngClass]="{'active-link': isActive('go-ten')}">
            गो-10
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link nav-link-custom" [ngClass]="{'active-link': isActive('contact-us')}"
            routerLink="contact-us">
            संपर्क
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link nav-link-custom"
            [ngClass]="{'active-link': isActive('doc-reupload') || isActive('govardhan-doc-reupload')}"
            routerLink="doc-reupload">
            त्रुटी असलेले अर्ज
          </a>
        </li>

        <!-- Applicant Login -->
        <!-- <li class="nav-item" *ngIf="!checkUserLogin()">
          <a class="nav-link nav-link-custom nav-link-btn" [ngClass]="{'active-link': isActive('empolyee')}" routerLink="empolyee">
            अर्जदार लॉगिन
          </a>
        </li> -->

        <li class="nav-item" *ngIf="!checkUserLogin()">
          <a class="nav-link nav-link-custom nav-link-btn" href="javascript:void(0)" (click)="openApplicantModal()">
            अर्जदार लॉगिन
          </a>
        </li>

        <!-- Officer Login -->
        <li class="nav-item" *ngIf="!checkUserLogin()">
          <a class="nav-link nav-link-custom nav-link-btn nav-link-btn--primary"
            [ngClass]="{'active-link': isActive('user-login')}" routerLink="user-login">
            अधिकारी लॉगिन
          </a>
        </li>

        <!-- User Profile Dropdown -->
        <li class="nav-item dropdown" *ngIf="checkUserLogin()">
          <a class="nav-link nav-link-custom d-flex align-items-center user-profile-trigger" data-bs-toggle="dropdown"
            href="#" role="button" aria-haspopup="true" aria-expanded="false">
            <div class="user-avatar">
              <img src="assets/images/home/avatar-1.png" alt="user" class="user-avatar-img">
            </div>
            <span class="user-name ms-2 d-none d-lg-inline">Hi, {{user.fullName}}</span>
            <svg class="dropdown-caret ms-1" width="10" height="6" viewBox="0 0 10 6">
              <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" />
            </svg>
          </a>
          <div class="dropdown-menu dropdown-menu-end profile-dropdown">
            <div class="profile-dropdown-header">
              <img src="assets/images/home/avatar-1.png" alt="user" class="profile-avatar-lg">
              <div>
                <div class="profile-name">{{user.fullName}}</div>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <a href="javascript:void(0);" class="dropdown-item profile-dropdown-item" (click)="logout()">
              <span class="profile-item-icon">⏻</span>
              <span>लॉगआउट</span>
            </a>
          </div>
        </li>

      </ul>
    </div>
  </div>
</nav>

<!-- APPLICANT VIDEO MODAL -->
<div class="modal fade" id="applicantVideoModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered applicant-modal-dialog">
    <div class="modal-content applicant-modal-content">


      <div class="apmod-hero">
        <div class="apmod-hero-pattern"></div>
        <div class="apmod-hero-top">
          <div class="apmod-badge">
            <span class="apmod-badge-dot"></span>
            महत्त्वाची सूचना
          </div>
          <button type="button" class="apmod-close" data-bs-dismiss="modal" aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1l12 12M13 1L1 13" stroke="white" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <div class="apmod-hero-body">
          <div class="apmod-scheme-tag">परिपोषण योजना &bull; दुसरा टप्पा</div>
          <h2 class="apmod-title">अनुदान मिळवण्यासाठी<br>कागदपत्रे अपलोड करा</h2>
          <p class="apmod-subtitle">माहे ऑक्टोबर २०२५ ते मार्च २०२६ – अनुदान वितरण प्रक्रिया सुरू</p>

        </div>
      </div>


      <div class="apmod-body">


        <div class="apmod-notice">
          <div class="apmod-notice-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <div>
            <div class="apmod-notice-title">अर्ज करण्यापूर्वी हे वाचा</div>
            <p class="apmod-notice-text">
              अनुदान वितरणाकरिता <strong>आवश्यक कागदपत्रे अपलोड</strong> करणे बाबत प्रक्रिया सुरू
              करण्यात आली आहे. खाली दिलेला <strong>मार्गदर्शन व्हिडिओ पाहून</strong> अर्ज सादर करा .
            </p>
          </div>
        </div>


        <div class="apmod-section-label">मार्गदर्शन व्हिडिओ</div>
        <div class="apmod-video-wrap">
          <iframe id="applicantYoutubeFrame" src="https://www.youtube.com/embed/T3Bl0CuFFS8"
            title="परिपोषण योजना मार्गदर्शन व्हिडिओ" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>


        <div class="apmod-steps">
          <div class="apmod-section-label">अर्ज प्रक्रिया – ३ सोपे टप्पे</div>
          <div class="apmod-steps-row">
            <div class="apmod-step">
              <div class="apmod-step-num">१</div>
              <div class="apmod-step-text">व्हिडिओ पाहा आणि प्रक्रिया समजून घ्या</div>
            </div>
            <div class="apmod-step">
              <div class="apmod-step-num">२</div>
              <div class="apmod-step-text">आवश्यक कागदपत्रे तयार ठेवा</div>
            </div>
            <div class="apmod-step">
              <div class="apmod-step-num">३</div>
              <div class="apmod-step-text">लॉगिन करून दस्तऐवज अपलोड करा</div>
            </div>
          </div>
        </div>

      </div>


      <div class="apmod-footer">
        <div class="apmod-footer-hint">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4l3 3" />
          </svg>
          व्हिडिओ पाहिल्यानंतर अर्ज करा
        </div>
        <div class="apmod-footer-btns">
          <button type="button" class="apmod-btn-skip" data-bs-dismiss="modal">नंतर पाहा</button>
          <button type="button" class="apmod-btn-proceed" (click)="goToApplicantLogin()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
            अर्ज करा
          </button>
        </div>
      </div>

    </div>
  </div>
</div>